export function toDateFromHoursAndMinutes(dateStr: string): Date {
  const tempTime = dateStr.split(':')
  const dt = new Date()
  dt.setHours(Number(tempTime[0]))
  dt.setMinutes(Number(tempTime[1]))
  dt.setSeconds(0)
  return dt
}
